export default "__VITE_ASSET__$Hfg$IZl__"